import { Image, Link, Text, View } from "@react-pdf/renderer";

import { styles } from "../../Tables";

export const TableRowEduEvdListaDefinisanihTacakaHeader: React.FC<{
  verifikacijaEfikasnosti: string;
  imePrezime: string;
  radnoMjesto: string;
  verifikacijaPrisustvaPotpis: string;
  verifikacijaEdukatoraPotpis: string;
  dokument: string;
}> = ({
  verifikacijaEfikasnosti,
  imePrezime,
  radnoMjesto,
  verifikacijaPrisustvaPotpis,
  verifikacijaEdukatoraPotpis,
  dokument,
}) => (
  <View style={styles.tableRow}>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{verifikacijaEfikasnosti}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{imePrezime}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{radnoMjesto}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{verifikacijaPrisustvaPotpis}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{verifikacijaEdukatoraPotpis}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{dokument}</Text>
    </View>
  </View>
);

export const TableRowEduEvdListaDefinisanihTacaka: React.FC<{
  verifikacijaEfikasnosti: string;
  imePrezime: string;
  radnoMjesto: string;
  verifikacijaPrisustvaPotpis: string;
  verifikacijaEdukatoraPotpis: string;
  dokument?: string;
  slikaRes: string;
}> = ({
  verifikacijaEfikasnosti,
  imePrezime,
  radnoMjesto,
  verifikacijaPrisustvaPotpis,
  verifikacijaEdukatoraPotpis,
  dokument,
  slikaRes,
}) => (
  <View style={styles.tableRow} wrap={false}>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{verifikacijaEfikasnosti}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{imePrezime}</Text>
    </View>
    <View style={styles.tableCol}>
      <Text style={styles.tableCell}>{radnoMjesto}</Text>
    </View>
    <View style={styles.tableCol}>
      {verifikacijaPrisustvaPotpis && (
        <Image
          style={[styles.tableCell, styles.signatureImage]}
          src={verifikacijaPrisustvaPotpis}
        />
      )}
    </View>
    <View style={styles.tableCol}>
      {verifikacijaEdukatoraPotpis && (
        <Image
          style={[styles.tableCell, styles.signatureImage]}
          src={verifikacijaEdukatoraPotpis}
        />
      )}
    </View>

    <View style={styles.tableCol}>
      {dokument && (
        <Link src={dokument} style={{ ...styles.tableCell, ...styles.link }}>
          {slikaRes}
        </Link>
      )}
    </View>
  </View>
);

export const TableEDUMainHeader: React.FC<{
  datumObuke: string;
  mjestoObuke: string;
  tip: string;
  izvrsilacObuke: string;
  tema: string;
  cilj: string;
  datumObukeres: string;
  mjestoObukeres: string;
  tipres: string;
  izvrsilacObukeres: string;
  temares: string;
  ciljres: string;
}> = ({
  datumObuke,
  mjestoObuke,
  tip,
  izvrsilacObuke,
  tema,
  cilj,
  datumObukeres,
  mjestoObukeres,
  tipres,
  izvrsilacObukeres,
  temares,
  ciljres,
}) => (
  <View style={styles.table}>
    <View style={styles.tableRow}>
      <View style={styles.tableColHorizontal}>
        <Text>{datumObukeres}</Text>
      </View>
      <View style={styles.tableColHorizontal}>
        <Text>{datumObuke}</Text>
      </View>
    </View>

    <View style={styles.tableRow}>
      <View style={styles.tableColHorizontal}>
        <Text>{mjestoObukeres}</Text>
      </View>
      <View style={styles.tableColHorizontal}>
        <Text>{mjestoObuke}</Text>
      </View>
    </View>

    <View style={styles.tableRow}>
      <View style={styles.tableColHorizontal}>
        <Text>{tipres}</Text>
      </View>
      <View style={styles.tableColHorizontal}>
        <Text>{tip}</Text>
      </View>
    </View>

    <View style={styles.tableRow}>
      <View style={styles.tableColHorizontal}>
        <Text>{izvrsilacObukeres}</Text>
      </View>
      <View style={styles.tableColHorizontal}>
        <Text>{izvrsilacObuke}</Text>
      </View>
    </View>

    <View style={styles.tableRow}>
      <View style={styles.tableColHorizontal}>
        <Text>{temares}</Text>
      </View>
      <View style={styles.tableColHorizontal}>
        <Text>{tema}</Text>
      </View>
    </View>

    <View style={styles.tableRow}>
      <View style={styles.tableColHorizontal}>
        <Text>{ciljres}</Text>
      </View>
      <View style={styles.tableColHorizontal}>
        <Text>{cilj}</Text>
      </View>
    </View>
  </View>
);
